import styled from 'styled-components';
import {dFlex, mobileMedia} from '../../../../globalVariables/GlobalVariables';

export const container = styled.div`
    ${dFlex};
    flex-direction: column;
    flex: 1;
    min-height: 0;
    ${mobileMedia} {
        border-radius: 0;
        border: none;
        overflow: visible;
        background: transparent;
        gap: var(--space-md);
    }
`;

export const separator = styled.hr`
    border: none;
    margin: 0;
    height: 1px;
    background: var(--TA-color-border-subtle);
    ${mobileMedia} {
        display: none;
    }
`;

